import { Injectable } from "@angular/core";
import { ScratchPadTableDefinitionFactory } from "../../model/ScratchPadTableDefinitionFactory";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { AccountLookupService } from "shared/cubiq-services/lookup/model/impl/AccountLookupService";
import {
  COLUMN_SALES_GROUP_ID,
  COLUMN_ENTRY_USER_ID,
} from "shared/cubiq-services/model/OrdersTableDefinitionFactory.constants";

@Injectable()
export class RawDataScratchPadAdapter extends BaseBlotterDataAdapter {
  constructor(
    protected _tableDefinitionFactory: ScratchPadTableDefinitionFactory,
    protected accountLookup: AccountLookupService,
  ) {
    super(_tableDefinitionFactory);
  }
}
